import { Component, Input, OnChanges } from "@angular/core";
import { sum } from "../../utils/sum";

@Component({
  selector: "ab-deploy-cards",
  templateUrl: "./deploy-cards.component.html",
})
export class DeployCardsComponent implements OnChanges {
  @Input() public deployData: any;
  @Input() public dur: string;
  @Input() public statData: any;
  public deployCountList: number[];
  public deploysWithNewErrorsCount: number;
  public totalDeploys: number;

  public ngOnChanges() {
    if (this.statData != null) {
      this.buildTotalDeployCardData(this.statData);
    }

    if (this.deployData != null) {
      this.deploysWithNewErrorsCount = this.deployData.count;
    }
  }

  private buildTotalDeployCardData(statData: any) {
    this.deployCountList = statData.count;
    this.totalDeploys = sum(this.deployCountList);
  }
}
